import en from './en'
import he from './he'
import pt from './pt'
import ru from './ru'
import es from './es'
import ar from './ar'
import pl from './pl'
import uk from './uk'
import ro from './ro'
import nl from './nl'
import cs from './cs'
import ml from './ml'
import sk from './sk'
import ka from './ka'
import si from './si'

export const executiveReportTexts = {
	en,
	he,
	pt,
	ru,
	es,
	ar,
	pl,
	uk,
	ro,
	nl,
	cs,
	ml,
	sk,
	ka,
	si,
}
